import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import Slider from 'react-slick';
import './ProductCarousel.scss';
import { v4 } from 'uuid';
import ButtonOwnDays from '../../../../CommonComponents/buttons/ButtonOwnDays/ButtonOwnDays';
import { useSelector } from 'react-redux';
import { replaceImageURL } from '../../../../own-days/helper';
import ChevronRightSlider from './../../../../../static/assets/svg/od-chevron-slider-right.svg';
import ChevronLeftSlider from './../../../../../static/assets/svg/od-chevron-slider-left.svg';
import { updateImageResolution } from '../../../../utils/helper';

const config = {
  accessibility: true,
  dots: false,
  arrows: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
};

const ProductCarousel = props => {
  const { productData, colorPreviewImageUrl, setShowTryOnPopUp, setShow360View } = props;
  const localeInfo = useSelector(state => state.common.localeInfo);

  const sliderRef = useRef(null);

  const sliderConfig = { ...config, ref: sliderRef };

  const { TRY_ON_VIRTUAL, VIEW360 } = props.dataLocale || {};
  const slidsList = useMemo(() => {
    return [...productData?.result?.imageUrlsDetail];
  }, [productData?.result?.imageUrlsDetail]);

  const [colorHoverImg, setColorHoverImg] = useState(colorPreviewImageUrl);

  useEffect(() => {
    setColorHoverImg(colorPreviewImageUrl);
  }, [colorPreviewImageUrl]);

  const prevSlide = () => {
    sliderRef.current.slickPrev();
  };

  const nextSlide = () => {
    sliderRef.current.slickNext();
  };

  async function loadImage(src) {
    const image = new Image();

    await new Promise((resolve, reject) => {
      image.onerror = () => {
        reject();
      };
      image.onload = resolve;
      image.src = src;
    });
  }

  const loadImages = useCallback(async () => {
    if (colorHoverImg) {
      try {
        await loadImage(colorHoverImg);
      } catch {
        setColorHoverImg(
          'https://static.lenskart.com/media/owndays/desktop/img/od-misc/no-image.jpg'
        );
      }
    }

    if (slidsList && slidsList.length > 0) {
      await Promise.all(
        slidsList.map(async slide => {
          try {
            await loadImage(replaceImageURL(slide.url, localeInfo, productData?.result?.id));
          } catch (error) {
            slide.url =
              'https://static.lenskart.com/media/owndays/desktop/img/od-misc/no-image.jpg';
          }
        })
      );
    }
  }, [colorHoverImg, localeInfo, productData?.result?.id, slidsList]);

  useEffect(() => {
    loadImages();
  }, []);

  return (
    <section className={`product-slider ${slidsList.length > 22 && 'dots'}`}>
      <div className="product-slider__arrows">
        <div className="arrows-container">
          <div className="arrow arrow-left" onClick={prevSlide}>
            <img alt="true" src={ChevronLeftSlider} />
          </div>
          <div className="arrow arrow-right" onClick={nextSlide}>
            <img alt="true" src={ChevronRightSlider} />
          </div>
        </div>
      </div>
      <Slider {...sliderConfig}>
        {slidsList.map(slide => {
          return (
            <div key={v4()} className="product-slider__slide-container">
              <img
                alt="product slide img"
                src={
                  colorHoverImg ||
                  updateImageResolution(
                    replaceImageURL(slide.url, localeInfo, productData?.result?.id),
                    '1080x1080'
                  )
                }
              />
            </div>
          );
        })}
      </Slider>
      {productData?.result?.classification !== 'contact_lens' && (
        <>
          {Number(productData?.result?.id) !== 221925 && productData?.result?.glassOnUrl ? (
            <div className="product-slider__btn">
              <ButtonOwnDays
                noHover
                classes="product-slider__btn__item product-slider__btn__item--first"
                fontClass="od-font-reg"
                fontSize="16px"
                mode="white-6"
                px="40px"
                py="16px"
                onClick={() => setShowTryOnPopUp(true)}
              >
                <img
                  alt="try on virtual"
                  src="https://static.lenskart.com/media/owndays/desktop/img/od-misc/icon-tryon-owndays.svg"
                />
                <span>{TRY_ON_VIRTUAL}</span>
              </ButtonOwnDays>
              <ButtonOwnDays
                noHover
                classes="product-slider__btn__item product-slider__btn__item--second"
                fontClass="od-font-reg"
                fontSize="16px"
                mode="white-6"
                px="40px"
                py="16px"
                onClick={() => setShow360View(true)}
              >
                <img
                  alt="view 360"
                  src="https://static.lenskart.com/media/owndays/desktop/img/od-misc/icon-360.svg"
                />
                <span>{VIEW360}</span>
              </ButtonOwnDays>
            </div>
          ) : null}
        </>
      )}
    </section>
  );
};

export default ProductCarousel;
